import { useState, useEffect } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import debounce from "lodash.debounce";
import { getDaysWithoutIncidentsService } from "../services/getDaysWithoutIncidents.service";

export const useDaysWithoutIncidentsQuery = () => {
  const fetchData = useFetch();
  const [daysWithoutIncidents, setDaysWithoutIncidents] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDaysWithoutIncidents = async () => {
      setLoading(true);
      try {
        const response = await getDaysWithoutIncidentsService(fetchData)();
        console.log(response)
        setDaysWithoutIncidents(response);
      } catch (error) {
        console.error("Error fetching days without incidents:", error);
      } finally {
        setLoading(false);
      }
    };

    const debouncedFetch = debounce(fetchDaysWithoutIncidents, 500);
    debouncedFetch();
    return () => {
      debouncedFetch.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    daysWithoutIncidents,
    loading,
  };
};
